module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ifLoadingStart),
      expression: "ifLoadingStart"
    }],
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../images/common/loading_2_24x24.gif"),
      "alt": ""
    }
  }), _vm._v("\n   数据加载中,请稍候...\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-1ff1cef0!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/loading.vue
// module id = ujTS
// module chunks = 15